import { Component, OnInit, Input } from '@angular/core';
import { Quote } from '../../models/quote.interface';
import { QuoteService } from '../../../quote/services/quote.service';
import { JobType } from '../../models/job.type.interface';
import { User } from '../../models/user.interface';

@Component({
  selector: 'app-quote-info-mobile',
  templateUrl: './quote-info.component.html',
  styleUrls: ['./quote-info.component.scss']
})
export class QuoteInfoComponent implements OnInit {
  quote: Quote;
  jobTypes: JobType[];
  quoteJobTypeDesc: string;
  quoteCreatedUser: User;

  constructor(private quoteService: QuoteService) { }

  ngOnInit(): void {
  }


  @Input()
  public set quoteInfo(value: Quote) {
    if (value) {
      this.quote = value;
    }
  }
  @Input()
  public set jobTypesList(value: JobType[]) {
    if (value) {
      this.jobTypes = value;
      let jobType = this.jobTypes.find(jt => jt.jobType_ID == this.quote.jobType_ID && jt.dealer_ID == this.quote.dealer_ID);
      this.quoteJobTypeDesc = jobType?.jobType_Desc;
    }
  }
}
